import $ from "jquery"

import "../scss/index.scss"

import React from 'react'
import ReactDOM from 'react-dom'

import Zitat from './components/Zitat'
import Zitate from './components/Zitate'


export function renderZitat(elem, zitat) {
    ReactDOM.render(
        <Zitat {...zitat}/>,
        elem,
    );
}

export function renderZitate(elem, zitate) {
    ReactDOM.render(
        <Zitate zitate={zitate}/>,
        elem,
    );
}


export function updateZitatDisplay($elem) {
    let url = $elem.data("url");
    $.getJSON(url, null, function(data) {
        renderZitat($elem[0], data);
        $elem.removeData("reload");
    });
}

$(function() {

    $(".zitat-wrapper[data-reload]").each(function(i, elem) {
        updateZitatDisplay($(elem));
    })

});


// WEBPACK FOOTER //
// ./cms_plugins/zitat_display/js/index.js